/* eslint-disable no-debugger */
const { NODE_ENV } = process.env;

export default {
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     let allowedEventIds = [];
  //     let redirect = '/';

  //     if (NODE_ENV === 'development') {
  //       allowedEventIds.push('testEvent');
  //     }

  //     if (vm.$route.path.indexOf('/learner-type') !== -1) {
  //       allowedEventIds = allowedEventIds.concat(['adt']);
  //       redirect = '/learner-type';
  //     }

  //     if (allowedEventIds.indexOf(vm.$route.params.eventId) === -1) {
  //       return vm.$router.push(redirect);
  //     }
  //   });
  // }
};